import React, { useState } from 'react';
import PrivacyPolicy from '../../pages/PrivacyPolicy';
import TermsAndConditions from '../../pages/TermsAndConditions'; // Import the TermsAndConditions component

const Footer = () => {
  const [isPrivacyOverlayOpen, setPrivacyOverlayOpen] = useState(false);
  const [isTermsOverlayOpen, setTermsOverlayOpen] = useState(false); // State for Terms and Conditions overlay

  return (
    <footer className="footer">
      <ul className="footer-links">
        <li>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setPrivacyOverlayOpen(true);
            }}
          >
            Privacy Policy
          </a>
        </li>
        <li>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setTermsOverlayOpen(true);
            }}
          >
            Terms and Conditions
          </a>
        </li>
      </ul>
      <PrivacyPolicy isVisible={isPrivacyOverlayOpen} onClose={() => setPrivacyOverlayOpen(false)} />
      <TermsAndConditions isVisible={isTermsOverlayOpen} onClose={() => setTermsOverlayOpen(false)} />
    </footer>
  );
};

export default Footer;